import React, { useEffect, useState } from "react";

interface SmartImageProps {
    src: string;
    alt?: string;
    wrapperClass: string
    className: string
}

const SmartImage: React.FC<SmartImageProps> = ({ src, alt, wrapperClass, className }) => {
    const [ratio, setRatio] = useState<number | null>(null);

    useEffect(() => {
        if (!src) return;
        const img = new Image();
        img.src = src;

        img.onload = () => {
            if (img.naturalWidth && img.naturalHeight) {
                setRatio(img.naturalWidth / img.naturalHeight);
            }
        };
    }, [src]);

    return (
        <div
            className={wrapperClass}
            style={
                ratio
                    ? { aspectRatio: `${ratio}` }
                    : { aspectRatio: "9 / 16" } // temporary fallback
            }
        >
            {
                (src) ? <img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    decoding="async"
                    className={className}
                /> : <div className={className} style={{width: '230px', background:'#cfcfcf', height: '100%'}}></div>
            }
        </div>
    );
};

export default SmartImage;
